enum DigitalAssetStatus {
    Y = 'Y',
    Y_NNA = 'Y_NNA',
    Y_DTIF = 'Y_DTIF',
}
export default DigitalAssetStatus;